var Actions;
(function (Actions) {
    Actions["GET_PROFIT_CENTER_LIST"] = "getProfitCenterList";
    Actions["GET_PROFIT_CENTER_LIST_ALLDATA"] = "getProfitCenterListAllData";
    Actions["UPDATE_PROFIT_CENTER_SIZE"] = "updateProfitCenterSize";
    Actions["GET_SELECTED_PROFIT_CENTER"] = "getSelectedProfitCenter";
    Actions["GET_CHECKED_PROFIT_CENTER"] = "getCheckedProfitCenter";
    Actions["UPDATE_PROFIT_CENTER_PAGE_FILTER"] = "updateProfitCenterPageFilter";
    Actions["UPDATE_PROFIT_CENTER_DESC"] = "updateProfitCenterDesc";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    // asset number for module mapping profilling, budget catalog
    Mutations["SET_PROFIT_CENTER_LIST"] = "setProfitCenterList";
    Mutations["SET_PROFIT_CENTER_HANDLE_PAGE"] = "setProfitCenterHandlePage";
    Mutations["SET_PROFIT_CENTER_PAGE"] = "setProfitCenterPage";
    Mutations["SET_PROFIT_CENTER_LOAD_PAGE"] = "setProfitCenterLoadPage";
    Mutations["SET_PROFIT_CENTER_LOADING"] = "setProfitCenterLoading";
    Mutations["SET_PROFIT_CENTER_STATUS"] = "setProfitCenterStatus";
    Mutations["SET_SELECTED_PROFIT_CENTER"] = "setSelectedProfitCenter";
    Mutations["SET_SELECTING_PROFIT_CENTER"] = "setSelectingProfitCenter";
    Mutations["SET_CHECKED_PROFIT_CENTER"] = "setCheckedProfitCenter";
    Mutations["SET_DROPDOWNLIST_PROFIT_CENTER"] = "setDropdownlistProfitCenter";
    Mutations["SET_PROFIT_CENTER_SIZE"] = "setProfitCenterSize";
    Mutations["SET_PROFIT_CENTER_HANDLE_SIZE"] = "setProfitCenterHandleSize";
    Mutations["SET_PROFIT_CENTER_PAGE_FILTER"] = "setProfitCenterPageFilter";
    Mutations["SET_PROFIT_CENTER_WAS_LOAD_QUICK_FILTER"] = "setProfitCenterWasLoadQuickFilter";
    Mutations["SET_PROFIT_CENTER_DESC"] = "setProfitCenterDesc";
    Mutations["SET_PROFIT_CENTER_SEARCH_BY"] = "setProfitCenterSearchBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
